import * as React from "react";
import { TableViewAction } from "./actions/TableViewAction";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import { TableViewRowData } from "./TableViewRowData";
import { ActionButton } from "./actions/ActionButton";
import "./TableView.css";
import { useState } from "react";
import { cloneDeep } from "lodash";
import { FormControlProps } from "react-bootstrap/FormControl";
import { BsPrefixProps, ReplaceProps } from "react-bootstrap/esm/helpers";

interface TableViewProps {
    headers: string[],
    data: TableViewRowData[],
    actions: TableViewAction[],
    tableId?: string,
    showSelectCheckBox?: boolean,
    setSelectedEntities?: (entities: any[]) => void,
    hideSelectAllLabel?: boolean,
    filterable?: boolean,
    verticalScrollbar?: boolean
}

export const TableView: React.FC<TableViewProps> = props => {
    const { headers, data, actions, tableId, showSelectCheckBox, filterable, setSelectedEntities, verticalScrollbar, hideSelectAllLabel } = props;
    const [filterValues, setFilterValues] = useState<{ rowIndex: number, value: string }[]>([]);

    // init checked fields on each data row, otherwise the check boxes will not work
    data.forEach(r => { if (r.checked === undefined) r.checked = false });

    const selectAll = (event: React.FormEvent<
        ReplaceProps<"input", BsPrefixProps<"input"> & FormControlProps>
    >) => {
        data.forEach(r => { if (rowPassesFilter(r)) r.checked = event.currentTarget.checked; });

        setFilterValues(cloneDeep(filterValues)); // hack to trigger refresh
        if (setSelectedEntities)
            setSelectedEntities(data.filter(r => r.checked).map(r => { return r.entity }));
    }

    const handleChange = (event: React.FormEvent<
        ReplaceProps<"input", BsPrefixProps<"input"> & FormControlProps>
    >, row: TableViewRowData) => {

        row.checked = event.currentTarget.checked;
        setFilterValues(cloneDeep(filterValues)); // hack to trigger refresh
        if (setSelectedEntities)
            setSelectedEntities(data.filter(r => r.checked).map(r => { return r.entity }));
    }

    const rowPassesFilter = (row: TableViewRowData) => {
        if (filterValues.length === 0) return true;

        for (var i = 0; i < filterValues.length; i++) {
            var filterValueRow = filterValues[i].rowIndex;
            var currentFilterValue = filterValues[i].value.toLowerCase();
            if (currentFilterValue !== "" && !row.cellContent[filterValueRow].toString().toLowerCase().includes(currentFilterValue)) {
                return false;
            }
        }

        return true;
    }

    const updateFilter = (rowIndex: number, event: React.FormEvent<ReplaceProps<"input", BsPrefixProps<"input"> & FormControlProps>>) => {
        var filterValueRow = filterValues.find(v => v.rowIndex === rowIndex)
        var newFilterValue = event.currentTarget.value ? event.currentTarget.value.toString() : "";

        if (newFilterValue && newFilterValue !== "") {
            if (filterValueRow) {
                filterValueRow.value = newFilterValue;
                setFilterValues(cloneDeep(filterValues));
            } else {
                var filterValuesClone = cloneDeep(filterValues);
                filterValuesClone.push({ rowIndex: rowIndex, value: newFilterValue });
                setFilterValues(filterValuesClone);
            }
        } else {
            if (filterValueRow) {
                setFilterValues(filterValues.filter(v => v !== filterValueRow));
            }
        }
    }

    const getScrollableTableClassName = () => {
        if (!verticalScrollbar || data.length < 6) return "";

        return "scrollable-table";
    }

    const getScrollableContainerClassName = () => {
        if (!verticalScrollbar || data.length < 6) return "";

        return "scrollable-table-container";
    }

    return <div className={getScrollableContainerClassName()}>
        <Table className={"table-sm table-striped " + getScrollableTableClassName()} id={tableId}>
            <thead>
                <tr>
                    {showSelectCheckBox && <th key={1}><div className="no-break"><Form.Check className="d-inline ml-1 mr-1" onClick={(e: any) => { selectAll(e) }} />{hideSelectAllLabel ? "" : "Select all"}</div></th>}
                    {headers.map((header, index) => {
                        return <th key={index + 1}>{header}</th>
                    })}
                    {actions.length > 0 && <th colSpan={actions.length}></th>}
                </tr>
            </thead>
            <tbody>
                {filterable && <tr>
                    {showSelectCheckBox && <td></td>}
                    {headers.map((header, index) => {
                        return <td key={index} className="pt-1 pb-1"><Form.Control
                            type="text"
                            onChange={(e: any) => {
                                updateFilter(index, e);
                            }}
                        /></td>
                    })}
                </tr>}
                {data.map((row, index) => {
                    if (rowPassesFilter(row)) {
                        return <tr key={index} className={row.getTrClass !== undefined ? row.getTrClass() : ""}>
                            {showSelectCheckBox && <td key={1}><Form.Check checked={row.checked} onChange={(e: any) => { handleChange(e, row) }} /></td>}
                            {row.cellContent.map((content, index2) => {
                                return <td key={index2 + 1}>{(typeof content === "boolean" ? (content ? <React.Fragment><i className="material-icons align-middle ascom-green">
                                    {"check_circle"}
                                </i> {"Yes"}</React.Fragment> : <React.Fragment><i className="material-icons align-middle ascom-red">
                                    {"radio_button_unchecked"}
                                </i> {"No"}</React.Fragment>) : content)}</td>
                            })}

                            {actions.map((action, index2) => {
                                return <td key={index2 + 1 + data.length} className="d-none d-sm-table-cell">
                                    <ActionButton action={action} entity={row.entity} />
                                </td>
                            })}
                        </tr>
                    }

                    return null;
                })}
            </tbody>
        </Table>
    </div>
}